import React from "react";

import Grid from "../../../layout/grid/grid";

export class TextLabel extends React.PureComponent {
	render() {
		const {
			meta: { touched, error }
		} = this.props;
		return (
			<Grid cols={this.props.cols} style={this.props.style}>
				<div
					className={`form-group ${touched && error && "has-error"}`}
				>
					{touched && error ? (
						<label className="control-label">
							<i className="fa fa-times-circle-o" />
							&nbsp;
							{this.props.label}
						</label>
					) : (
						<label htmlFor={this.props.name}>
							{this.props.label}
						</label>
					)}
					<textarea
						{...this.props.input}
						style={this.props.inputStyle}
						className="form-control"
						placeholder={this.props.placeholder}
						readOnly={this.props.readOnly}
						type={this.props.type}
					>
						{this.props.input.value}
					</textarea>
					{touched && error && (
						<span className="help-block">{error}</span>
					)}
				</div>
			</Grid>
		);
	}
}